<h1 mat-dialog-title>{{ this.ga.id ? "Edit" : "New" }} GA</h1>
<div mat-dialog-content>

  <form class="example-form">

    <lf-select-search [listElements]="suppliers" placeholder="GA Supplier (No. / Name) *"
      placeholderLabel="search supplier" (selected)="this.onSupplierChanged($event)"
      [selectedElementId]="ga.supplier_id" />

    <lf-select-search [listElements]="items" placeholder="Item (No. / Name) *" placeholderLabel="item"
      (selected)="this.onItemChanged($event)" [selectedElementId]="ga.item_id" />

    <mat-form-field>
      <mat-label>GA price *</mat-label>
      <input matInput #ga_price [(ngModel)]="ga.price"
        [ngModelOptions]="{standalone: true}">
      </mat-form-field>

      <mat-form-field style="float:right;">
        <mat-label>VAT %</mat-label>
        <input matInput #vat_perc [(ngModel)]="ga.vat_perc"
          [ngModelOptions]="{standalone: true}">
        </mat-form-field>

        <lf-select-search [listElements]="currencies" placeholder="Currency *" placeholderLabel="currency"
          (selected)="this.onCurrencyChanged($event)" [selectedElementId]="ga.currency_id" />

        <mat-form-field style="width: 100%;">
          <mat-label>GA incoterm</mat-label>
          <mat-select [(ngModel)]="ga.ga_incoterm" [ngModelOptions]="{standalone: true}" required>
            @for (incoterm of incoterms; track incoterm) {
              <mat-option [value]="incoterm.name">
                {{incoterm.name}}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>

        <mat-form-field>
          <mat-label>Effective date</mat-label>
          <input matInput [matDatepicker]="picker1"
            [(ngModel)]="ga.effective_date" required [ngModelOptions]="{standalone: true}" [min]="minDate">
            <mat-datepicker-toggle matSuffix [for]="picker1" />
            <mat-datepicker #picker1 />
          </mat-form-field>

          <mat-form-field style="float:right;">
            <mat-label>Valid to</mat-label>
            <input matInput [matDatepicker]="picker2" [(ngModel)]="ga.invalid_date"
              [ngModelOptions]="{standalone: true}" [min]="minDate">
              <mat-datepicker-toggle matSuffix [for]="picker2" />
              <mat-datepicker #picker2 />
            </mat-form-field>

          </form>
        </div>

        <div mat-dialog-actions>
          <button mat-button (click)="onNoClick()">Cancel</button>
          <button mat-button (click)="onOkClick()" cdkFocusInitial>Ok</button>
        </div>
